import React, { useState } from 'react';

const InputPassword = ({
    name,
    label,
    formError,
    value,
    onChange,
    className = "col-md-6"
}) => {
    const [isShowPassword, setIsShowPassword] = useState(false);

    const handleShowPassword = () => {
        setIsShowPassword((prevState) => !prevState);
    };

    return (
        <div className={className}>
            <label className="form-label">{label}</label>
            <div className="input-group">
                <input
                    type={isShowPassword ? "text" : "password"}
                    className={`form-control ${formError && formError[name] && formError[name].length > 0 ? 'is-invalid' : ''}`}
                    name={name}
                    value={value || ''}
                    onChange={onChange}
                />
                <button
                    onClick={handleShowPassword}
                    type="button"
                    className="pass-input-show input-group-text bg-transparent"
                >
                    <i className={`bx bx-${!isShowPassword ? 'hide' : 'show'}`}></i>
                </button>
            </div>
            {formError?.[name] && (
                <div className="invalid-feedback">
                    {formError[name].join(', ')}
                </div>
            )}
        </div>
    );
};

export default InputPassword;
